/* eslint-disable react/function-component-definition */
import { Button, Card, Center, Image, Stack, Text } from '@mantine/core';

type ActionButtonProps = {
  label: string;
  onClick: () => void;
};

type CardEmptyProps = {
  message?: string;
  image?: string;
  actionButtonProps?: ActionButtonProps;
};

const CardEmpty = ({ message, image, actionButtonProps }: CardEmptyProps) => {
  const hasRichContent = image || actionButtonProps;

  if (hasRichContent) {
    return (
      <Card>
        <Stack align="center">
          {image && <Image src={image} w="var(--dimension-xl5)" alt="" />}
          <Text variant="body-md" ta="center">
            {message}
          </Text>
          {actionButtonProps && (
            <Center>
              <Button onClick={actionButtonProps.onClick}>{actionButtonProps.label}</Button>
            </Center>
          )}
        </Stack>
      </Card>
    );
  }

  return (
    <Card p="xl" bg="var(--surface-secondary)" radius="var(--mantine-radius-xs)" ta="center">
      <Text variant="sublabel-md" c="var(--content-secondary)" fz="md">
        {message || 'No Results'}
      </Text>
    </Card>
  );
};

export default CardEmpty;
